import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoggedApp from './LoggedAppContainer';
import PublicApp from './PublicAppContainer';
const _reqByAuth = require('../api/reqByAuth');
const glb = window;

function isLogged(state) {
  let isLogged = false;
  glb.authReq = new _reqByAuth.default();
  if(state.login){
    isLogged = state.login.logged ? state.login.logged : false;
  }
  return glb.authReq.isAuth();
}

class MainContainer extends Component {
  componentWillMount() {
    MainContainer.handleLocationChange(this.props.history.location);
  }

  componentDidMount() {
    this.unsubscribeFromHistory = this.props.history.listen(MainContainer.handleLocationChange);
  }

  shouldComponentUpdate() {
    return true;
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  }

  static handleLocationChange(location = '/', action) {
    // console.log(location, action);
  }

  render() {
    const loggedRoutes = require('../routes/index').loggedRoutes(this.props.store);
    const publicRoutes = require('../routes/index').publicRoutes(this.props.store);

    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          <Router basename={process.env.REACT_APP_ROUTER_BASE || ''} history={this.props.history}>
            {this.props.logged
              ? <LoggedApp loggedRoutes={loggedRoutes} publicRoutes={publicRoutes} />
              : <PublicApp publicRoutes={publicRoutes} />}
          </Router>
        </div>
      </Provider>
    );
  }
}

MainContainer.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  logged: PropTypes.bool,
};

const mapStateToProps = state => ({
  logged: isLogged(state),
});

export default connect(mapStateToProps)(MainContainer);
